<template>
    <Portal selector="#v2-sidebar">
        <div id="v2-sidebar-container">
            <div id="v2-sidebar-container-inner" :style="buildStyle">
                <slot></slot>
            </div>
        </div>
    </Portal>
</template>

<script>
    import { Portal } from "@linusborg/vue-simple-portal";

    export default {
        name: "PortalSidebar",
        components: {
            Portal,
        },
        data: function() {
            return {
                windowHeight: 0, // window.visualViewport.height ? window.visualViewport.height : window.innerHeight,
            }
        },
        methods: {
            /*
            fixPanelHeight() {
                const panel = document.getElementById('v2-sidebar-container-inner');
                console.log(panel);
                panel.height = window.innerHeight - 40;
                console.log("Height:", panel.height);
            }

             */
            updateHeight() {
                console.log('Height:', this.windowHeight);
                this.windowHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
                console.log('New Height:', this.windowHeight);
                //return this.windowHeight;
            },
        },
        computed: {
            buildStyle() {
                /*
                let windowHeight = window.visualViewport.height ? window.visualViewport.height : window.innerHeight;
                // const windowHeight = window.innerHeight - 40;
                windowHeight = windowHeight - 40;
                return `height: ${windowHeight}px;`;
                 */
                let innerHeight = this.windowHeight - 40;
                return `height: ${innerHeight}px;`;
            }
        },
        mounted: function() {
            // Add a class hint to the rest of the page outside the vue app...
            document.body.classList.add('v2-has-sidebar');

            // this.fixPanelHeight();
            this.updateHeight();
            window.addEventListener('resize', this.updateHeight);
        },
    }
</script>

<style>
/* SIDEBAR STYLING - Passive style for when it's optional */
#v2-wrapper {
    display: flex;
    flex-direction: row;
}
#v2-core {
    flex-grow: 1;
    max-width: 1170px;
    margin: 0 auto;
}
#v2-sidebar {
    max-width: 300px;
    background-color: #f0f0f0;
}

#primarybuttonrow {
    max-width: 1200px;
    margin: 0 auto;
}
#admin-breadcrumbs { /* backend */
    max-width: 1170px;
    margin: 0 auto;
}
/* Active styling for when #v2-sidebar-container is being injected  */
#v2-sidebar-container {
    width: 300px;
    /*border-left: 1px solid #999;*/
    height: 100%; /* Essential or position:sticky; on child element won't work */
}
#v2-sidebar-container-inner {
    position: sticky;
    top: 40px;
}

/*body.v2-has-sidebar {*/

/*}*/
</style>